
import { computed, defineComponent } from 'vue';
import { getAppointmentEndDate, getAppointmentIcon, getAppointmentStartDate, getAppointmentTitleString } from 'JS/automotive/auto-service-scheduler/utils/helpers';
import { IconName } from 'JS/constants/icons';
import { IServiceConfirmationResource, IWorkOrderConfirmationProductResource, IWorkOrderConfirmationResource } from 'JS/types/Automotive';
import { PropType } from 'vue';
import { WorkOrderAppointmentInfo, WorkOrderAppointmentInfoState, WorkOrderType } from 'JS/automotive/auto-service-scheduler/types/session';

export default defineComponent({
	name: 'AppointmentService',
	components: {
	},
	props: {
		hideTime: {
			type: Boolean,
			default: false,
		},
		isProduct: {
			type: Boolean,
			default: false
		},
		service: {
			type: Object as PropType<IServiceConfirmationResource>,
			required: false
		},
		workOrder: {
			type: Object as PropType<IWorkOrderConfirmationResource>,
			required: true
		},
	},
	setup(props) {
		const orderType = computed<WorkOrderType>(() => props.workOrder.type);

		const appointmentInfo = computed<WorkOrderAppointmentInfo>(() => props.workOrder.appointmentInfo);
		const startDate = computed<Date>(() => getAppointmentStartDate(appointmentInfo.value));

		const appointmentIcon = computed<IconName>(() => getAppointmentIcon(orderType.value));
		const appointmentTitle = computed(() => getAppointmentTitleString(orderType.value));

		const appointmentDateShort = computed(() => {

			if (isApponintmentInProgress(appointmentInfo.value)) {
				return "In Progress " + startDate.value.toLocaleDateString('en-us');
			}

			return "Upcoming " + startDate.value.toLocaleDateString('en-us');

		});

		const product = computed<IWorkOrderConfirmationProductResource>(() => props.workOrder.primaryProductInfo );
		const productName = computed(() => product.value.name );
		const serviceIcon = computed(() => props.service.icon);
		const serviceName = computed(() => props.isProduct ? appointmentTitle.value : props.service.name);
		const serviceClass = computed(() => {

			if (isApponintmentInProgress(appointmentInfo.value)) {
				return 'in-progress';
			}

			return 'upcoming';
		});

		const groupSize = computed(() => {
			const groupSizeAttr = product.value.selectedAttributes.find(attr => attr.attributeDescription == "Group Size");
			if (!groupSizeAttr) return;
			return groupSizeAttr.attributeValue;
		});


		function isApponintmentInProgress(appointmentInfo: WorkOrderAppointmentInfo) {
			if (appointmentInfo.state === WorkOrderAppointmentInfoState.Empty) return false;

			const todayTime = new Date().getTime();
			const orderStartDate: Date = getAppointmentStartDate(appointmentInfo);
			const orderEndDate: Date = getAppointmentEndDate(appointmentInfo);
			return orderStartDate?.getTime() < todayTime && orderEndDate?.getTime() > todayTime;

		}


		return {
			appointmentTitle,
			appointmentIcon,
			appointmentDateShort,
			groupSize,
			product,
			productName,
			serviceIcon,
			serviceName,
			serviceClass
		};
	}
});
